import { ForbiddenException } from './Exceptions';
import {
    UserPermissions,
    RolePermissions,
    QuickBooksPermissions,
    BankingReconciliationPermissions
} from './../constants/Permissions';
import { PermissionCategories } from '../constants/Enums';
import { RoleTypes } from './../constants/Enums';

export {
    UserHasPermission,
    isLimitedAccessRole
};
//Returns boolean value
//Takes in user's permissions, plus 
function UserHasPermission(userPermissions, permissionCategory, cb) {
    if (userPermissions == null || userPermissions.permissions == null)
        return false;
    const permissions = userPermissions.permissions;
    if (permissions == null || Object.keys(permissions).length === 0)
        return false;
    const permissionKeys = Object.keys(permissions);
    const permissionsToCheckAgainst = getPermissionsFromPermissionCategory(permissionCategory);
    return permissionKeys.some(p => permissionsToCheckAgainst.includes(p));
}

function getPermissionsFromPermissionCategory(permissionCategory) {
    switch (permissionCategory) {
        case PermissionCategories.USERS:
            return UserPermissions;
        case PermissionCategories.ROLES:
            return RolePermissions;
        case PermissionCategories.QUICK_BOOKS:
            return QuickBooksPermissions;
        case PermissionCategories.BANKING_RECONCILIATION :
            return BankingReconciliationPermissions;
        default:
            throw new ForbiddenException("Invalid permission category supplied");
    }
}

function isLimitedAccessRole(permissions) {
    if (permissions != null && Object.keys(permissions).length !== 0) {
        if (permissions.roleType === null || permissions.roleType === undefined)
            return false;
        else {
            let roleType = permissions.roleType;
            return roleType === RoleTypes.LIMITED_ACCESS;
        }
    }
}
